import { ErrorBoundaryFallbackUI } from 'common-hooks';
import { A, Badge, Box, Button, ErrorScreen, P } from 'design-system';
import React from 'react';

export const WebErrorScreen: ErrorBoundaryFallbackUI<{
  stats: string[];
}> = ({ dismiss, error, stats, email }) => {
  return (
    <ErrorScreen title="Something’s not quite right">
      <Button onClick={dismiss}>Try again</Button>

      <P>If trying again did not work, restart the web application.</P>
      <P>
        If the problem persists, write to{' '}
        <A href={`mailto:${email}`}>{email}</A> with a screenshot of the error
        you’re seeing.
      </P>
      <Badge
        size="small"
        color="lightRed"
        css={{
          fontWeight: 'unset',
          textTransform: 'unset',
        }}
      >
        {error.message}
      </Badge>
      <Box>
        {stats.map((stat, index) => (
          <React.Fragment key={index}>
            <Badge css={{ display: 'inline' }}>{stat}</Badge>{' '}
          </React.Fragment>
        ))}
      </Box>
    </ErrorScreen>
  );
};
